import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const recyclingProductFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'categoryLike',
    label: '수거 품목 명',
    placeholder: '품목명을 입력해주세요',
  },
  {
    key: 'isExposed',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.exposed, value: 'true' },
      { label: OPTIONS_CONST.notExposed, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'isEventProduct',
    label: '이벤트 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.applied, value: 'true' },
      { label: OPTIONS_CONST.notApplied, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
];
